import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';
import { MaterialModule } from './modules/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KlesMaterialDynamicformsModule } from '@3kles/kles-material-dynamicforms';
import { KlesMaterialTableModule } from '@3kles/kles-material-table';
import { KlesTreetableComponent } from './component/treetable.component';
import { KlesTreetableDirective } from './directives/treetable.directive';
import { DefaultKlesTreetableService } from './services/defaulttreetable.service';
import { ConverterService } from './services/converter.service';
import { TreeService } from './services/tree.service';
import { KlesDynamicCellDirective } from './directives/dynamic-cell.directive';
import { LeafComponent } from './component/cell/leaf.component';
import { NodeComponent } from './component/cell/node.component';
import { KlesTreetableService } from './services/treetable.service';
const components = [KlesTreetableComponent, LeafComponent, NodeComponent];
const directives = [KlesTreetableDirective, KlesDynamicCellDirective];
const services = [DefaultKlesTreetableService, ConverterService, TreeService, KlesTreetableService];
const pipes = [];

@NgModule({
    declarations: [
        components,
        directives,
        pipes
    ],
    imports: [
        CommonModule,
        MaterialModule,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        KlesMaterialDynamicformsModule,
        KlesMaterialTableModule
    ],
    exports: [
        components,
        directives,
        pipes,
    ],
    entryComponents: [
        components,
    ],
    providers: [
        services
    ]
})

export class KlesMaterialTreetableModule { }
